import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';
import { RecommendationService } from '../../recommendation';
import {
  loadRecommendationsForContext,
  recommendationsForContextLoadError,
  recommendationsForContextLoaded,
} from './recommendations.actions';

@Injectable()
export class RecommendationEffects {
  loadRecommendationsForContext$ = createEffect(() =>
    this.actions.pipe(
      ofType(loadRecommendationsForContext),
      mergeMap((action: ReturnType<typeof loadRecommendationsForContext>) => {
        const { context, includeLearnerProfileConcepts, includeLearnerProfileStrand } = action;
        const options = { includeLearnerProfileConcepts, includeLearnerProfileStrand };

        const request$ = this.recommendationService.getRecommendationsForContext(context, options).pipe(
          switchMap((response) => {
            const { recommendations = [], learnerProfileConcepts = [], learnerProfileStrand } = response || {};

            return of(
              recommendationsForContextLoaded({
                context,
                recommendations,
                learnerProfileConcepts,
                learnerProfileStrand,
              })
            );
          }),
          catchError((error) => of(recommendationsForContextLoadError({ error })))
        );

        // use switchMap to handle the case where context.tocId is present, so we cancel the previous request for other tocs
        // use mergeMap to handle the case where context.tocId is not present, so we don't cancel the previous request (For dashboard)
        return context.tocId ? of(action).pipe(switchMap(() => request$)) : of(action).pipe(mergeMap(() => request$));
      })
    )
  );

  constructor(
    private actions: Actions,
    private recommendationService: RecommendationService
  ) {}
}
